import type {
  FailureFlagsAppsProtectQueryParams,
  GetAppsQueryKeyParams
} from 'queries/failure-flags/types'

export const failureFlagsQueryKeys = {
  getApp: (appName: string, teamId: string) =>
    [`failure-flags/apps/${appName}`, { teamId }] as const,
  getApps: (params: GetAppsQueryKeyParams) =>
    ['failure-flags/apps', params] as const,
  getExperiment: (experimentId: string | undefined, teamId: string) =>
    [
      { experimentId, baseUrl: `failure-flags/experiments/${experimentId}` },
      { teamId }
    ] as const,
  getExperiments: (teamId: string) =>
    ['failure-flags/experiments', teamId] as const,
  getExperimentsActive: (query: Record<string, string | number | null>) =>
    ['failure-flags/experiments/active', query] as const,
  getExperimentsCompletedPaged: (params: {
    pageSize: number
    teamId: string
  }) => ['failure-flags/experiments/completed/paged', params] as const,
  getFlag: (failureFlagName: string, teamId: string) =>
    [
      `failure-flags/flags/${failureFlagName}`,
      { failureFlagName, teamId }
    ] as const,
  getFlags: (teamId: string) => ['failure-flags/flags', teamId] as const
}

export const failureFlagsMutationKeys = {
  postAppsProtect: ({
    appName,
    ...params
  }: FailureFlagsAppsProtectQueryParams) =>
    [`failure-flags/apps/${appName}/protect`, params] as const,
  postAppsUnprotect: ({
    appName,
    ...params
  }: FailureFlagsAppsProtectQueryParams) =>
    [`failure-flags/apps/${appName}/unprotect`, params] as const
}
